
import SVG from "react-inlinesvg";
import { ConfirmOrderStatus } from "../../../../Store/ConfirmOrder/types";

type Props = {
    statusType: ConfirmOrderStatus;
    statusDetail?: string;
    resendVerificationCode: () => void;
}

const ConfirmOrderStatusHandler: React.FC<Props> = ({ statusType = "ORDER_ID_MISSING", statusDetail, resendVerificationCode }) => {
    
    return (
        <>
            <div className="main-wrapper confirm-order-screens">
                <div className="cards-wrap card-success">
                    <div className="card-body confirm-order-model">
                        <div className="header w-100 justify-content-center">
                            <div className="logo mb-5">
                                {" "}
                                <SVG
                                    className="header-logo"
                                    src="Assets/Images/Logos/kiddo.svg"
                                    width="108"
                                    height="32"
                                />{" "}
                            </div>
                            <div className="text-center">
                                {statusType === "ORDER_ID_MISSING" && (
                                    <>
                                        <h1 className="text-error title-medium text-center fs-5 mb-3">Order Id is missing</h1>
                                        <p className="header-text">
                                            We didn't find the order id specified or is missing in the link, <br /> contact <b>Kiddo Support</b> or your <b>Provider</b>.
                                        </p>
                                    </>
                                )}
                                
                                {statusType === "INVALID_ORDER" && (
                                    <>
                                        <h1 className="text-error title-medium text-center fs-5 mb-3">Order is already confirmed</h1>
                                        <p className="header-text">
                                            This order was previously confirmed, the current status is 
                                            <br />
                                            <b>{statusDetail === "Ordered" ? "Confirmed" : statusDetail}</b>
                                        </p>
                                    </>
                                )}
                                
                                {statusType === "EMAIL_ERROR" && (
                                    <>
                                        <h1 className="text-error title-medium text-center fs-5 mb-3">Verification code not sent</h1>
                                        <p className="header-text">
                                            We were not able to send the verification code to your email due to following error:
                                            <br />
                                            {statusDetail}
                                        </p>
                                    </>
                                )}

                                {statusType === "VERIFICATION_CODE_ERROR" && (
                                    <>
                                        <h1 className="text-error title-medium text-center fs-5 mb-3">Error in verification code</h1>
                                        <p className="header-text">
                                            Error while verifying the code.
                                        </p>
                                    </>
                                )}

                                {statusType === "RESPONSE_ERROR" && (
                                    <>
                                        <h1 className="text-error title-medium text-center fs-5 mb-3">Something went wrong</h1>
                                        <p className="header-text">
                                            Something went wrong during the process, Please retry.
                                        </p>
                                    </>
                                )}

                                {statusType === "INVALID_ORDER_ID" && (
                                    <>
                                        <h1 className="text-error title-medium text-center fs-5 mb-3">Order Not Found</h1>
                                        <p className="header-text">
                                            Ohh no, we didn't find this order in our books
                                        </p>
                                    </>
                                )}

                                {statusType === "CODE_EXPIRED" && (
                                    <>
                                        <h1 className="text-error title-medium text-center fs-5 mb-3">Code expired</h1>
                                        <p className="header-text">
                                            Verification Code is expired, please request new verification code.
                                        </p>
                                    </>
                                )}
                                
                                {statusType === "ORDER_CONFIRMED" && (
                                    <>
                                        <h1 className="text-success title-medium text-center fs-5 mb-3">Order confirmed</h1>
                                        <p className="header-text">
                                            Thank you for confirming order for Kiddo Band for your child, {statusDetail}
                                            <br />
                                            You will receive an email when your band ships, and can expect to receive your band within 4-5 business days. If you have any additional questions, please reach out to the Kiddo team.
                                            <br />
                                            You can close this tab now.
                                        </p>
                                        <p>
                                            <a href="https://kiddo.health" target="_blank" className="btn btn-success" rel="noreferrer">Visit our website</a>
                                            <br />
                                            <br />
                                            <a href="mailto:membersupport@kiddo.health" className="btn btn-success">Contact Kiddo Health</a>
                                        </p>
                                    </>
                                )}
                                
                            </div>
                        </div>
                        <div className="card-inner confirm-order">
                            {statusType === "CODE_EXPIRED" && (
                                <>
                                    <button type="button" className="btn btn-success btn-reverse" onClick={resendVerificationCode}>Resend Code</button>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ConfirmOrderStatusHandler;